// extracted by mini-css-extract-plugin
export default {"tabMenu":"TabMenu_tabMenu__Ojy6e","tabMenuItem":"TabMenu_tabMenuItem__yOF0S","tabMenuItemText":"TabMenu_tabMenuItemText__mUOVu","selected":"TabMenu_selected__C98M2"};